"use client";

import { Heading, Text } from "@pamperedchef/design-system";

import {
	ListingAppliedFilters,
	ListingFilters,
	ListingSort,
	useListingTotal
} from "../../listing-state";

import * as styles from "./ResultsToolbar.module.scss";

export interface ResultsToolbarProps {
	showCount: boolean;
	heading?: string;
}

export function ResultsToolbar({
	showCount,
	heading
}: ResultsToolbarProps): JSX.Element {
	const total = useListingTotal();

	return (
		<div className={styles["toolbar"]} data-component="ResultsToolbar">
			{heading ? (
				<Heading tag="h2" className={styles["toolbar__heading"]}>
					{heading}
				</Heading>
			) : null}
			<div className={styles["toolbar__row"]}>
				{showCount ? (
					<Text
						tag="p"
						className={styles["toolbar__count"]}
						aria-live="polite"
					>
						Showing <strong>{total}</strong>{" "}
						{total === 1 ? "result" : "results"}
					</Text>
				) : null}
				<div className={styles["toolbar__actions"]}>
					<div className={styles["toolbar__drawer"]}>
						<ListingFilters presentation="drawer" />
					</div>
					<ListingSort />
				</div>
			</div>
			<div className={styles["toolbar__chips"]}>
				<ListingAppliedFilters />
			</div>
		</div>
	);
}
